import React from 'react';
import { Image, Grid, Divider } from 'semantic-ui-react';
import LinkButton from '../UtilityComponents/LinkButton';
import withDataFetch from '../../api/withDataFetch';
import { renderDataAsHtml, renderDataAsPlainText } from '../../api/renderPrismicData';
import withFullScreenLoading from '../UtilityComponents/withFullScreenLoading';
import bannerImage from '../../assets/images/logo.gif';
import './Home.css';

const Home = ({
  data: {
    title,
    image: { url: image },
    image1: { url: image1 },
    image2: { url: image2 },
    paragraph,
    paragraph1,
    paragraph2,
    paragraph3,
    subtitle: subTitle,
    subtitle1: subTitle1,
    subtitle2: subTitle2,
  },
}) => {
  return (
    <Grid className="Home">
      <Grid.Row columns="equal" className="Home__Intro">
        <Grid.Column textAlign="center">
          <h2 className="Page__Title">
            {renderDataAsPlainText(title)}
          </h2>
          <Image
            className="Home__Intro__Image"
            rounded
            centered
            size="small"
            src={bannerImage}
          />
          <h3 className="Home__Intro__SubTitle">
            {renderDataAsPlainText(subTitle)}
          </h3>
          <LinkButton link="/diensten" text="Ontdek onze diensten" />
          <LinkButton link="/registreer" text="Info registratie" />
        </Grid.Column>
      </Grid.Row>
      <Divider />

      <Grid.Row className="Home__Organisatie">
        <Grid.Column mobile={16} tablet={8} computer={10}>
          {renderDataAsHtml(paragraph)}
          <div className="Buttons Buttons--CenterMobile">
            <LinkButton link="/jtv" text="Over JTV" />
            <LinkButton link="/opleiding" text="Over opleidingen" />
          </div>
        </Grid.Column>
        <Grid.Column verticalAlign="middle" mobile={16} tablet={8} computer={6}>
          <Image fluid rounded centered src={image} />
        </Grid.Column>
      </Grid.Row>
      <Divider />

      <Grid.Row reversed="computer tablet">
        <Grid.Column mobile={16} tablet={8} computer={10}>
          {renderDataAsHtml(subTitle1)}
          {renderDataAsHtml(paragraph1)}
        </Grid.Column>
        <Grid.Column verticalAlign="middle" mobile={16} tablet={8} computer={6}>
          <Image fluid rounded centered src={image1} />
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column>
          {renderDataAsHtml(paragraph2)}
          <div className="Home__Services__Buttons Buttons Buttons--CenterMobile">
            <LinkButton link="/diensten" text="Meer over onze diensten" />
            <LinkButton link="/klinieken" text="Onze klinieken" />
          </div>
        </Grid.Column>
      </Grid.Row>
      <Divider />

      <Grid.Row className="Home__Prevention">
        <Grid.Column mobile={16} tablet={8} computer={10}>
          {renderDataAsHtml(subTitle2)}
          {renderDataAsHtml(paragraph3)}
          <div className="Buttons Buttons--CenterMobile">
            <LinkButton link="/diensten" text="Meer over preventie" className="Home__Prevention__Button" />
          </div>
        </Grid.Column>
        <Grid.Column verticalAlign="middle" mobile={16} tablet={8} computer={6}>
          <Image fluid rounded centered src={image2} />
        </Grid.Column>
      </Grid.Row>
      <Divider />
    </Grid>
  );
};

export default withDataFetch(withFullScreenLoading(Home), 'homepage');



// WEBPACK FOOTER //
// ./src/components/Home/index.js